module.exports = __webpack_public_path__ + "static/media/Slots_Purple@3x.7c2bbc0b.png";